/**
 * Component that looks like a button - it's used inside the gallery.
 * It's not a real button as the entire gallery is already a clickable area
 * and we don't want a button inside a button or button inside an anchor tag (invalid HTML).
 * It's using asChild Radix pattern to render as a simple <div> instead of <button>.
 */

import { Button } from '@bridebook/aura';
import { HeartSolid } from '@bridebook/aura/src/icons';

export const SaveToShortlistFakeButton = () => (
  <Button
    variant="tertiary"
    icon={HeartSolid}
    size="standard"
    aria-hidden="true"
    className="text-blush-tangerine-120"
    asChild>
    <div />
  </Button>
);
